module.exports = __webpack_public_path__ + "img/2.da513a0f.png";